import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Alert, Container, Stack, Text, Title } from "@mantine/core";
import { formatAxiosErrorMessage, postOrThrow } from "../../../../_api";
import PageForm from "../PageForm/PageForm";

const AddPage: React.FC = () => {
  const history = useHistory();
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <Container size="md" py="xl" pb={250}>
      <Stack gap="lg">
        <Title order={1}>Nowa strona</Title>
        {submitError && (
          <Alert
            color="red"
            variant="filled"
            title="Nie zapisano strony"
            withCloseButton
            onClose={() => setSubmitError(null)}
            style={{ position: "sticky", top: 0, zIndex: 200 }}
          >
            <Text size="sm" c="white" style={{ whiteSpace: "pre-wrap" }}>
              {submitError}
            </Text>
          </Alert>
        )}
        <PageForm
          onSubmit={async (values) => {
            setSubmitError(null);
            try {
              const res = await postOrThrow("dynamic-pages", values);
              if (res) history.push("/pages");
            } catch (e) {
              setSubmitError(formatAxiosErrorMessage(e));
            }
          }}
        />
      </Stack>
    </Container>
  );
};

export default AddPage;
